export const styles = {
  root: {
    marginTop: 6,
    minWidth: 306,

    '&.MuiPaper-root': {
      margin: 0,
      padding: 0,
    },
  },
  alertTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  alertTitleContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  alertRoot: {
    boxShadow: 2,
    background: 'white',
  },
  completedRequest: {
    color: 'success.dark',
  },
  requestHistoryRoot: {
    display: 'flex',
    alignItems: 'center',
  },
  requestHistoryContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  requestHistoryTitle: {
    color: 'gray.80',
  },
  requestHistoryDate: {
    color: 'gray.56',
  },
  icon: {
    color: 'success.dark',
  },
  upRightIconStyles: {
    color: 'primary.main',
  },
}
